import { useHref } from 'react-router-dom';

export const useBaseName = (): string => {
    const baseName = useHref('/');

    return baseName === '/' ? '' : baseName;
};
